import convert from "xml-js"
import _ from "lodash"

export const returnSlideArrayFromXml = (xml_string) => {
  console.log("returnSlideArrayFromXml")
  var data = convert.xml2js(xml_string, {compact: true, spaces: 4});
  console.log(data);
  var slideArray = _.map(data.edit.slides.slide, s => {
    return {
      caption: s.caption._text,
      end_percent_scale: (s.end_percent_scale === undefined) ? 100: s.end_percent_scale._text,
      end_percent_x: (s.end_percent_x === undefined) ? 0: s.end_percent_x._text,
      end_percent_y: (s.end_percent_y === undefined) ? 0: s.end_percent_y._text,
      file: s.file._text,
      start_percent_scale: (s.start_percent_scale === undefined) ? 100: s.start_percent_scale._text,
      start_percent_x: (s.start_percent_x === undefined) ? 0: s.start_percent_x._text,
      start_percent_y: (s.start_percent_y === undefined) ? 0: s.start_percent_y._text,
      timing: parseInt(s.timing._text, 10),
    }
  })
  return slideArray
}

export const returnLowerthirdsArrayFromXml = (xml_string) => {
  console.log("returnLowerthirdsArrayFromXml")
  var data = convert.xml2js(xml_string, {compact: true, spaces: 4});
  // xml2js-compact is weird. If an array is single, it returns the item rather than the array.
  var ltArray;
  if(Array.isArray(data.edit.lower_thirds.item)){
    ltArray = _.map(data.edit.lower_thirds.item, s => {
      return {
        name: s.name._text,
        title: s.title._text,
        inpoint: parseInt(s.inpoint._text, 10),
        duration: parseInt(s.duration._text, 10)
      }
    })
  }else{
    ltArray = _.map(data.edit.lower_thirds, s => {
      return {
        name: s.name._text,
        title: s.title._text,
        inpoint: parseInt(s.inpoint._text, 10),
        duration: parseInt(s.duration._text, 10)
      }
    })
  }
  return ltArray
}


export const returnShowMetaData = (xml_string) => {
  console.log("returnShowMetaData")
  var data = convert.xml2js(xml_string, {compact: true, spaces: 4});
  console.log(data);
  var meta = {};
  _.each(data.edit.meta.item, i => {
    meta[i.parameter._text] = i.value._text;
  });
  return meta;
}

export const returnImageDirectoryFromMeta = (metaDict) => {
  if("fullscreen" in metaDict && metaDict.fullscreen == "true"){
    return "fullscreen";
  }
  if("custom_size" in metaDict && metaDict.custom_size == "true"){
    return "custom";
  }
  return "600_450";
}
